import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import MainDashboard from "../../../components/Trader/MainDashboard";

const TraderDashboard = () => {

  return <MainDashboard />;
};

export default TraderDashboard;
